/**
 * MHH Experience System — Version 3 foundation JavaScript
 * Minimal: reduced-motion sync, breakpoint root class, no customer UI.
 */
(function () {
  'use strict';

  var docEl = document.documentElement;
  if (!docEl) return;

  docEl.classList.add('mhh-exp-js');

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  function syncReducedMotion() {
    docEl.classList.toggle('mhh-exp-reduced-motion', motionQuery.matches);
  }
  syncReducedMotion();
  if (typeof motionQuery.addEventListener === 'function') {
    motionQuery.addEventListener('change', syncReducedMotion);
  } else if (typeof motionQuery.addListener === 'function') {
    motionQuery.addListener(syncReducedMotion);
  }

  var breakpoints = {
    tablet: 768,
    desktop: 1024,
    wide: 1440
  };

  function syncBreakpointClass() {
    var w = window.innerWidth;
    docEl.classList.remove(
      'mhh-exp-bp-mobile',
      'mhh-exp-bp-tablet',
      'mhh-exp-bp-desktop',
      'mhh-exp-bp-wide'
    );
    if (w >= breakpoints.wide) {
      docEl.classList.add('mhh-exp-bp-wide');
    } else if (w >= breakpoints.desktop) {
      docEl.classList.add('mhh-exp-bp-desktop');
    } else if (w >= breakpoints.tablet) {
      docEl.classList.add('mhh-exp-bp-tablet');
    } else {
      docEl.classList.add('mhh-exp-bp-mobile');
    }
  }

  syncBreakpointClass();
  window.addEventListener('resize', syncBreakpointClass, { passive: true });
})();
